var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _path13, _path14, _path15, _path16, _path17, _path18, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeepOceanSubmarine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#1B2432"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0587 25.2125C12.656 27.0765 15.1307 37.7517 14.976 39.1073L29.6693 33.0072C26.2666 29.7877 18.7808 23.7214 16.0587 25.2125Z",
    fill: "#52BDA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0587 64.9556C12.656 63.0917 15.1307 52.4164 14.976 51.0608L29.6693 57.161C26.2666 60.3805 18.7808 66.4467 16.0587 64.9556Z",
    fill: "#52BDA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57015 45.6273C6.40665 42.6235 4.77775 36.0903 7.57015 33.9876C10.3626 31.885 8.73365 40.8713 7.57015 45.6273Z",
    fill: "#52BDA4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57015 45.6275C6.40665 48.3582 4.77775 54.2975 7.57015 56.209C10.3626 58.1205 8.73365 49.9511 7.57015 45.6275Z",
    fill: "#52BDA4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5272 29.5114C77.0168 31.5313 77.9997 36.8703 77.9997 44.8337L77.9999 45.3038C78.0044 56.8139 78.0073 63.9753 52.865 63.9753C28.196 63.9753 10.5806 55.2854 9.48055 46.6087H8.7301C8.67827 47.1404 8.55312 47.685 8.31948 48.2029C7.32364 50.4103 5 47.0992 5 45.9955C5 44.8918 8.00882 42.4391 8.31948 43.5428C8.45988 43.8886 8.62403 44.4596 8.70645 45.1371H9.44849C9.95277 38.3342 18.9079 33.444 35.5704 30.6981C36.1866 28.521 37.1918 25.443 38.8732 24.1467C41.0316 22.4825 44.3376 19.9553 49.237 18.9523C49.237 14.4074 49.237 13.5062 50.347 11.6552C51.6708 9.44774 54.0622 9.07076 56.3993 9.04542C56.8878 9.04013 57.3298 9.03533 57.7124 9C57.9657 9.43382 58.2559 10.2728 58.1728 11.2531C58.1228 11.8431 57.7124 13.1696 57.7124 13.1696C57.7124 13.1696 55.8486 13.2577 55.0185 13.1696C53.5183 13.0103 52.7299 13.5415 52.3148 13.9568C51.8642 14.4076 51.815 14.9774 51.856 18.6884C55.0234 18.8604 68.5272 19.4431 68.5272 24.1467V29.5114Z",
    fill: "#F1AE5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0862 22.9692C67.717 19.5725 55.0467 16.6707 51.864 16.2099C51.8299 16.9847 51.8566 18.6875 51.864 19.3642C54.064 19.485 66.0858 20.876 68.0862 22.9692Z",
    fill: "#52BDA4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2889 16.2099C46.8622 16.2241 42.8516 16.8941 41.0492 18.9135C39.6972 20.4281 38.9424 22.8856 39.2467 23.8704C44.2035 20.2654 47.8084 19.3642 49.2889 19.3642C49.2239 18.5496 49.3104 17.1636 49.2889 16.2099Z",
    fill: "#52BDA4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6416 30.6296C37.6659 29.9076 58.316 29.5114 68.086 29.2858C66.856 28.5713 62.1397 27.1649 53.1147 27.2552C41.8335 27.368 41.0349 22.8806 39.2425 24.7984C37.8087 26.3326 36.0985 29.0127 35.6416 30.6296Z",
    fill: "#F97953"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6114 17.1109C49.6095 17.0582 49.6077 17.0068 49.6062 16.9566C49.6078 17.0076 49.6095 17.0591 49.6114 17.1109Z",
    fill: "#F97953"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6114 17.1109C49.6095 17.0582 49.6077 17.0068 49.6062 16.9566C49.5251 14.3482 49.8248 12.8418 50.9633 11.7035L50.964 11.7028C52.3156 10.3513 53.2167 9.45028 57.2715 9.45044L57.2716 11.2529C56.034 10.6928 53.1658 11.0999 51.4142 13.0554C49.7151 14.9522 49.5563 15.3321 49.6062 16.9566C49.6078 17.0076 49.6095 17.0591 49.6114 17.1109Z",
    fill: "#F97953"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0988 45.0494C66.2552 47.2129 65.3357 46.7472 10.2847 47.2881C12.1721 55.6288 26.5164 60.7226 44.258 62.6817C73.8312 64.8452 75.5888 57.5879 77.0988 52.4941C77.0988 51.3792 77.0988 46.2249 77.0988 45.0494Z",
    fill: "#F97953"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45021 47.2881C8.01984 50.1432 5 47.829 5 46.2064C5.71478 46.2777 7.74474 47.2202 8.45021 47.2881Z",
    fill: "#F97953"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.6998,
    cy: 14.1903,
    rx: 13.6998,
    ry: 14.1903,
    transform: "matrix(0.894018 0.448031 -0.409149 0.912468 45.3936 27.154)",
    fill: "#4292A4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.71803,
    cy: 9.03017,
    rx: 8.71803,
    ry: 9.03017,
    transform: "matrix(0.894018 0.448031 -0.409149 0.912468 47.7344 34.0948)",
    fill: "#A4D0DA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3883 46.0337C65.414 47.9152 65.0888 49.7837 64.4314 51.5324C63.774 53.2811 62.7972 54.8758 61.5568 56.2254C60.3165 57.575 58.8368 58.6532 57.2023 59.3983C55.5678 60.1433 53.8105 60.5408 52.0307 60.5679C50.2509 60.595 48.4835 60.2512 46.8294 59.5562C45.1753 58.8612 43.6668 57.8286 42.3902 56.5173C41.1136 55.206 40.0937 53.6417 39.389 51.9138C38.6842 50.1858 38.3082 48.328 38.2826 46.4465L51.8355 46.2401L65.3883 46.0337Z",
    fill: "#33717F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4586 46.1305C60.4862 48.5488 59.6039 50.8796 58.006 52.6101C56.408 54.3407 54.2252 55.3293 51.9377 55.3585C49.6503 55.3876 47.4456 54.4549 45.8086 52.7656C44.1717 51.0763 43.2365 48.7686 43.2089 46.3504L51.8338 46.2405L60.4586 46.1305Z",
    fill: "#5BABBD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3394 60.6033C29.9722 50.8616 31.9364 35.8476 33.3394 31.4764L30.9435 31.8547C28.4582 41.3153 29.4655 55.5145 30.6012 59.8467L33.3394 60.6033Z",
    fill: "#52BDA4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6003 60.4582C66.9613 49.4606 69.9295 35.5758 71.7947 30.4872L69.4059 29.7284C65.3026 41.0017 65.6122 50.7431 68.2114 61.2169L70.6003 60.4582Z",
    fill: "#52BDA4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6743 37.6952C75.6746 36.2186 73.3758 33.7142 72.2263 32.6466C70.6384 32.2873 70.9358 34.2003 71.7793 34.6219C72.6229 35.0435 73.1932 37.1337 73.4658 38.6951C73.7385 40.2565 75.674 39.5409 75.6743 37.6952Z",
    fill: "#CCE6E2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0485 24.3227C66.6797 22.7632 63.5144 20.6677 61.9778 19.8148C60.1339 19.8148 60.9406 21.7642 61.9778 22.0078C63.015 22.2515 64.1674 24.3227 64.8589 25.9065C65.5503 27.4903 67.5095 26.272 67.0485 24.3227Z",
    fill: "#CCE6E2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.1953,
    y: 43.454,
    width: 14.3904,
    height: 5.4333,
    rx: 2.71665,
    fill: "#33717F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeepOceanSubmarine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DeepOceanSubmarine.90ac197e1e136e6db8188e3008f06604.svg";